import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  ChartData,
  ChartOptions,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

// Đăng ký components cho Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

interface RevenueChartProps {
  title: string;
  labels: string[];
  currentPeriodData: number[];
  previousPeriodData?: number[];
  showPreviousPeriod?: boolean;
}

const RevenueChart: React.FC<RevenueChartProps> = ({
  title,
  labels,
  currentPeriodData,
  previousPeriodData = [],
  showPreviousPeriod = false,
}) => {
  const formatCurrency = (value: number): string => {
    return new Intl.NumberFormat('vi-VN', {
      style: 'currency',
      currency: 'VND',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  };

  const options: ChartOptions<'line'> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        align: 'end',
        labels: {
          usePointStyle: true,
          boxWidth: 6,
        },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || '';
            if (label) {
              label += ': ';
            }
            if (context.parsed.y !== null) {
              label += formatCurrency(context.parsed.y);
            }
            return label;
          },
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          callback: function (value) {
            return formatCurrency(value as number);
          },
        },
      },
    },
  };

  const data: ChartData<'line'> = {
    labels,
    datasets: [
      {
        label: 'Hiện tại',
        data: currentPeriodData,
        borderColor: 'rgb(59, 130, 246)',
        backgroundColor: 'rgba(59, 130, 246, 0.1)',
        tension: 0.3,
        fill: true,
      },
    ],
  };

  if (showPreviousPeriod && previousPeriodData.length > 0) {
    data.datasets.push({
      label: 'Kỳ trước',
      data: previousPeriodData,
      borderColor: 'rgb(156, 163, 175)',
      backgroundColor: 'rgba(156, 163, 175, 0.1)',
      borderDash: [5, 5],
      tension: 0.3,
      fill: false,
    });
  }

  return (
    <div className='bg-white rounded-lg shadow p-5'>
      <h2 className='text-lg font-semibold mb-4'>{title}</h2>
      <div className='h-80'>
        <Line options={options} data={data} />
      </div>
    </div>
  );
};

export default RevenueChart;
